import { render, staticRenderFns } from "./ActivityCenter.vue?vue&type=template&id=e0aaa7ca&scoped=true&"
import script from "./ActivityCenter.vue?vue&type=script&lang=js&"
export * from "./ActivityCenter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCenter.vue?vue&type=style&index=0&id=e0aaa7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aaa7ca",
  null
  
)

component.options.__file = "ActivityCenter.vue"
export default component.exports